import { React, useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import "../css/Home.css";
import "../css/Disclaimer.css";
import { Helmet } from "react-helmet";
import DisclaimerPrivacy from "./DisclaimerPrivacy";
import DisclaimerExercise from "./DisclaimerExercise";
import DisclaimerContent from "./DisclaimerContent";
import DisclaimerTerms from "./DisclaimerTerms"; // new component for TOS
import { useLocation, useNavigate } from "react-router-dom";

function Disclaimer() {
  const location = useLocation();
  const navigate = useNavigate();
  const [displayText, setDisplayText] = useState(null);
  const [selectedTab, setSelectedTab] = useState("privacy");

  // helper to change tab & update URL
  const showTab = (tab) => {
    setSelectedTab(tab);
    navigate(`?tab=${tab}`);
    switch (tab) {
      case "privacy":
        setDisplayText(<DisclaimerPrivacy />);
        break;
      case "disclaimer":
        setDisplayText(<DisclaimerExercise />);
        break;
      case "content":
        setDisplayText(<DisclaimerContent />);
        break;
      case "terms":
        setDisplayText(<DisclaimerTerms />);
        break;
      default:
        setDisplayText(<DisclaimerPrivacy />);
    }
  };

  // set initial tab from URL or default
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (tabParam) {
      showTab(tabParam);
    } else {
      showTab("privacy");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <div className="page">
      <Helmet>
        <title>thenics4all</title>
        <meta
          name="description"
          content="Step-by-step Handstand pushup progressions, training and tutorials."
        />
        <meta
          name="keywords"
          content="handstand, handstand pushup, hspu, calisthenics, progression, tutorial"
        />
      </Helmet>
      <Container fluid>
        <div className="home-row row-long">
          <div className="fixed-header">
            <h1>
              <div className="disclaimer-nav">
                <span
                  className={`disclaimer-nav-link ${selectedTab === "privacy" ? "active" : ""}`}
                  onClick={() => showTab("privacy")}
                >
                  Privacy
                </span>
                <span className="disclaimer-nav-separator">|</span>
                <span
                  className={`disclaimer-nav-link ${selectedTab === "disclaimer" ? "active" : ""}`}
                  onClick={() => showTab("disclaimer")}
                >
                  Exercise Disclaimer
                </span>
                <span className="disclaimer-nav-separator">|</span>
                <span
                  className={`disclaimer-nav-link ${selectedTab === "content" ? "active" : ""}`}
                  onClick={() => showTab("content")}
                >
                  Content Use
                </span>
                <span className="disclaimer-nav-separator">|</span>
                <span
                  className={`disclaimer-nav-link ${selectedTab === "terms" ? "active" : ""}`}
                  onClick={() => showTab("terms")}
                >
                  Terms of Service
                </span>
              </div>
              <hr className="disclaimer-horizontal-rule" />
            </h1>
          </div>
          <div className="disclaimer-text left">{displayText}</div>
        </div>
      </Container>
    </div>
  );
}

export default Disclaimer;
